import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons'
import Modal from 'react-responsive-modal'

import styles from './Credits.module.css'

class Credits extends Component {
  state = {
    creditsModalOpen: false,
  }

  onOpenCreditsModal = () => {
    this.setState({ creditsModalOpen: true })
  }

  onCloseCreditsModal = () => {
    this.setState({ creditsModalOpen: false })
  }

  render() {
    const { items } = this.props
    const { creditsModalOpen } = this.state

    return (
      <>
        <button className={styles[`modal-trigger`]} onClick={this.onOpenCreditsModal}>
          Créditos <FontAwesomeIcon icon={faPlusCircle} className={styles[`modal-trigger-icon`]} />
        </button>
        <Modal
          open={creditsModalOpen}
          onClose={this.onCloseCreditsModal}
          center
          classNames={{ modal: styles[`modal`] }}
        >
          <h3 className={styles[`modal-title`]}>Créditos</h3>
          <div className={styles[`modal-body`]}>
            <div>
              {items.map((credit, index) => (
                <div className={styles[`credits-row`]} key={index}>
                  <h3>{credit.label}</h3>
                  <div dangerouslySetInnerHTML={{ __html: credit.content }} />
                </div>
              ))}
            </div>
          </div>
        </Modal>
      </>
    )
  }
}

Credits.propTypes = {
  items: PropTypes.array,
}

export default Credits
